export enum ViewType {
  Buttons,
  List,
}
